























import { Component, Vue } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { APPLICATION_USER_DATA } from '@/queries/Application';
import { GQL_applicationUserData_currentUser } from '@/queries/__generated__/applicationUserData';
import ApplicationModeService from '@/utils/application-mode-service';
import { ISnotrVideo } from '@/components/VideoPopup.vue';
import VideoTutorials from '@/app/VideoTutorials';

@Component({
  components: {
    FailedInvoiceDeliveriesWarning: () => import('@/components/Invoicing/Invoice/FailedInvoiceDeliveriesWarning.vue'),
    GeneralInvoiceStatistics: () => import('./GeneralInvoiceStatistics.vue'),
    VideoPopup: () => import('@/components/VideoPopup.vue'),
    PaycheckList: () => import('@/components/Paycheck/PaycheckList.vue'),
  },
})
export default class Dashboard extends Vue {
  @SmartQuery(APPLICATION_USER_DATA) private currentUser!: GQL_applicationUserData_currentUser;
  private ApplicationModeService = ApplicationModeService;
  private videos: ISnotrVideo[] = VideoTutorials;
}
